export const REQUEST_QUOTATION_SUCCESS = 'REQUEST_QUOTATION_SUCCESS';

export const requestQuotationSuccess = (useLeadPostedSuccessRedirectUrl: boolean) => ({
  type: REQUEST_QUOTATION_SUCCESS,
  data: useLeadPostedSuccessRedirectUrl,
});
